export default __webpack_public_path__ + "static/media/Armbands of the Farseeker.72ff0714.jpg";